// prettier-ignore
export const pipe = (...fns) => x => fns.reduce((v, f) => f(v), x);
export const kbFix = weight => (weight / 1024 >= 1 ? weight / 1024 : weight).toFixed(2);
export const phonePurify = phone => phone.replace(/[^+\d]/g, ''); // ? href
export const phonePrettify = phone =>
  phone.replace(/\D+/g, '').replace(/(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})/, '+$1 ($2) $3-$4-$5');

// prettier-ignore
const addZero = (number, len = 2) => Array(Math.max(0, len - number.toString().length)).fill('0').join('') + number;
export const datePrettify = (format = 'D.M.Y', date = new Date()) => {
  const time = new Date(date);
  const Y = time.getFullYear();
  const M = addZero(time.getMonth() + 1);
  const D = addZero(time.getDate());
  const h = addZero(time.getHours());
  const m = addZero(time.getMinutes());
  const s = addZero(time.getSeconds());
  const i = addZero(addZero(time.getMilliseconds()), 3);
  const data = { Y, M, D, h, m, i, s };
  return format.replace(/[YMDhmsi]/g, char => data[char]);
};

export const getCity = (origin, env = 'msk') => {
  if (!new RegExp(/^https:\/\/[a-z-_]+\.[a-z-_]+\./).test(origin)) return env;
  const possible = origin.slice(origin.indexOf('//') + 2, origin.indexOf('.'));
  const stopList = ['website', 'test', 'app', 'spec', 'release', 'new', 'uberi', 'beta', 'alpha', 'project'];
  return stopList.includes(possible) ? env : possible;
};

export const debounce = (fn, ms = 0) => {
  let timeoutId;
  return function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => fn(...args), ms);
  };
};

const prefix = (pattern = /^[?/&$]/, v) => (v?.match(pattern) ? v.slice(1) : v);
const postfix = (pattern = /[?/&$]$/, v) => (v?.match(pattern) ? v.slice(0, v.length - 1) : v);
export const urlFix = pipe(prefix.bind(null, /^[?/&$]/), postfix.bind(null, /[?/&$]$/));
export const queryFix = pipe(prefix.bind(null, /^[?&$]/), postfix.bind(null, /[?&$]$/));

export const jsonParse = buffer => {
  if (buffer?.length === 0) return null;
  try {
    return JSON.parse(buffer);
  } catch {
    return null;
  }
};
